// src/api/axiosInstance.js
import axios from "axios";
import { loaderRef } from "./context/LoaderContext";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL|| "http://localhost:3000/api",
  timeout: 15000,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    loaderRef.startLoading?.(); // ✅ SAFE CALL

      const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    loaderRef.stopLoading?.();
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    loaderRef.stopLoading?.();
    return response;
  },
  (error) => {
    loaderRef.stopLoading?.();

      // Auto-logout on 401
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/LoginPage"; // ← matches your existing login route
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
